import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import ChildAttendanceCalendar from "../ChildAttendenceCalendar";

const MyReportsHistoryDialog = ({ open, onClose, visitsInfo, decisionMonth }) => {
    const { t } = useTranslation();


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{t('myReportsHistory_viewReport')}</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0' }}>
                    <ChildAttendanceCalendar
                        visitsInfo={visitsInfo || []}
                        selectedDate={moment(decisionMonth)}
                        noData={!visitsInfo || visitsInfo.length === 0}
                        hideNavigation={true}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MyReportsHistoryDialog;
